import { render } from "./HistoryView.vue?vue&type=template&id=77d7578e"
import script from "./HistoryView.vue?vue&type=script&lang=js"
export * from "./HistoryView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__